import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";
import { setAccounts } from "../modules";
import { RegionsManager } from "../services";
import { mapApiRoute } from "../utils";
import { useAuth } from "./useAuth";
import { useUpdateCurrentAccount } from "./useCurrentAccount";
import { useRestApi } from "./useRestApi";
import { useValidSession } from "./useValidSession";
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
var processAccounts = function(param) {
    var allowed_api_keys = param.allowed_api_keys, master_api_key = param.master_api_key;
    var masterAccount = allowed_api_keys.find(function(param) {
        var key = param.key;
        return key === master_api_key;
    });
    var accounts = [];
    if (masterAccount) {
        var key = masterAccount.key, postpaid = masterAccount.postpaid, secret = masterAccount.secret;
        accounts.push({
            key: key,
            postpaid: postpaid,
            secret: secret
        });
    }
    return accounts.concat(allowed_api_keys.filter(function(param) {
        var key = param.key, suspended = param.suspended;
        return !suspended && key !== master_api_key;
    }).map(function(param) {
        var key = param.key, postpaid = param.postpaid, secret = param.secret;
        return {
            key: key,
            postpaid: postpaid,
            secret: secret
        };
    }));
};
export var useUserAccounts = function() {
    var _currentRegion;
    var dispatch = useAppDispatch();
    var _useAuth = useAuth(), accountId = _useAuth.accountId, saveAccountId = _useAuth.saveAccountId;
    var accounts = useAppSelector(function(param) {
        var collection = param.accounts;
        return collection;
    }).accounts;
    var isAuthenticated = useValidSession();
    var isMock = import.meta.env.MODE !== "production" && import.meta.env.VITE_MOCK;
    var fetchApi = useRestApi().fetchApi;
    var cacheBust = useRef(Date.now());
    var shouldSkip = !isMock && (accounts.length > 0 || !isAuthenticated);
    var _useSWR = useSWR(shouldSkip ? null : [
        mapApiRoute("".concat((_currentRegion = new RegionsManager().currentRegion) === null || _currentRegion === void 0 ? void 0 : _currentRegion.marketApiUrl, "/proxy/ai-studio/info?_=").concat(cacheBust.current)),
        cacheBust.current
    ], fetchApi, {
        revalidateIfStale: true,
        revalidateOnFocus: false
    }), data = _useSWR.data, error = _useSWR.error, isValidating = _useSWR.isValidating;
    useUpdateCurrentAccount();
    useEffect(function() {
        if (!isAuthenticated) return;
        if (data && Array.isArray(data.allowed_api_keys)) {
            if (Array.isArray(data.allowed_api_keys)) {
                var accounts = processAccounts(data);
                dispatch(setAccounts(accounts));
                if (accounts.length && !accountId) {
                    saveAccountId(accounts[0].key);
                }
            }
        }
    }, [
        accountId,
        data,
        dispatch,
        error,
        isAuthenticated,
        saveAccountId
    ]);
    return {
        data: accounts,
        error: error,
        loading: isValidating || typeof isAuthenticated === "undefined" || isAuthenticated && (data === null || data === void 0 ? void 0 : data.allowed_api_keys) && (!accountId || !(accounts === null || accounts === void 0 ? void 0 : accounts.length))
    };
};

//# sourceMappingURL=useUserAccounts.js.map